import { createApp } from 'vue';
import { createPinia } from 'pinia';
import CartButton from './shop/components/CartButton.vue';
import AddToCartButton from './shop/components/AddToCartButton.vue';
import OrderSummary from './shop/components/checkout/OrderSummary.vue';
import Address from './shop/components/Address.vue';
import { i18n } from './shop/i18n/index.ts';

const pinia = createPinia();

const components = {
    cartButton: CartButton,
    addToCart: AddToCartButton,
    orderSummary: OrderSummary,
    address: Address,
};

const propsExtractors = {
    addToCart: (el) => ({ variants: JSON.parse(el.dataset.variants) }),
    orderSummary: (el) => ({ showShoppingCart: el.dataset.showShopppingCart === 'true' }),
    address: (el) => ({
        addressType: el.dataset.addressType,
        countriesList: el.dataset.countries ? JSON.parse(el.dataset.countries) : {},
        initialAddress: el.dataset.address ? JSON.parse(el.dataset.address) : {},
        errors: el.dataset.errors ? JSON.parse(el.dataset.errors) : {},
    }),
};

document.querySelectorAll('[data-shop-component]').forEach((el) => {
    const key = el.dataset.shopComponent;
    const component = components[key];
    const props = propsExtractors[key]?.(el) ?? {};
    createApp(component, props).use(pinia).use(i18n).mount(el);
});
